import React from "react";
import styled from "styled-components";

//components
import PageError from "../common/PageError/pageError.component";
import Header from "../common/Header/Header.component";

//hooks
import useAuth from "../../hooks/useAuth";
import usePageError from "../../hooks/usePageError";

//styles
import { bgHeaders } from "../../styles/theme";

const ContentWrapper = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
`;

const PageWrapper = styled.div`
  flex: 1; 
  padding: calc(15 * var(--atom)) calc(2 * var(--atom)) calc(2 * var(--atom));
  // max-height: calc(100vh - calc(12.8 * var(--atom)));
  // background-color: ${bgHeaders};

  @media (max-width: 480px) {
    max-height: calc(100vh - calc(25.8 * var(--atom)));
    padding-top: calc(27 * var(--atom));
  }
`;

interface Props {
  children: JSX.Element;
}

const AppWrapper: React.FC<Props> = ({ children }) => {
  const { user } = useAuth();
  const { visibleError } = usePageError();

  return (
    <ContentWrapper>
      {visibleError && <PageError />}
      {user && <Header />}
      <PageWrapper>{children}</PageWrapper>
    </ContentWrapper>
  );
};

export default AppWrapper;
